// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import waitFor from "@insite/client-framework/Common/Utilities/waitFor";
import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import { ApiHandler, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import { AutocompleteApiParameter } from "@insite/client-framework/Services/AutocompleteService";
import { chain, RequestDataFromApi } from "@insite/client-framework/Store/CommonHandlers/GetAutocompleteModel";
import loadRealTimePricing from "@insite/client-framework/Store/CommonHandlers/LoadRealTimePricing";
import { AutocompleteModel } from "@insite/client-framework/Types/ApiModels";

type HandlerType = ApiHandler<AutocompleteApiParameter & HasOnSuccess<AutocompleteModel>, AutocompleteModel>;

export const UpdatePrice: HandlerType = async props => {
    if (!props.apiResult?.products || props?.apiResult?.products?.length === 0) {
        return;
    }

    let loadedPricing = false;
    props.dispatch(
        loadRealTimePricing({
            productPriceParameters: props.apiResult.products!.map(
                o =>
                    ({
                        productId: o.id! || "",
                        unitOfMeasure: o.properties["uom"] || "",
                        qtyOrdered: o.properties["minQty"] || "1",
                    } as any),
            ),
            onComplete: (realTimePricingProps: any) => {
                if (realTimePricingProps?.apiResult) {
                    realTimePricingProps.apiResult.realTimePricingResults?.forEach((pricing: any) => {
                        props.apiResult.products = props.apiResult.products!.map(product => {
                            if (
                                product.id === pricing.productId &&
                                (product.properties.uom || "") === pricing.unitOfMeasure
                            ) {
                                product.properties.pricing = pricing;
                            }
                            return product;
                        });
                    });
                } else if (realTimePricingProps.error) {
                    props.apiResult.products = props.apiResult.products!.map(product => {
                        product.properties["failedToLoadPricing"] = "true";
                        return product;
                    });
                }
                loadedPricing = true;
            },
        }),
    );

    await waitFor(() => loadedPricing);
};

addToChainAfter(chain, RequestDataFromApi, UpdatePrice);
